import ArchiveIcon from '@mui/icons-material/Archive';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuArchiveButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label' | 'onClick'
> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuArchiveButton: React.FC<ContextMenuArchiveButtonProps> = ({
  onClick,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const { onCloseMenu } = useContextMenuContext();

  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<ArchiveIcon fontSize="medium" sx={{ marginTop: '1px' }} />}
      label={translate('app.buttons.archive')}
      {...restProps}
      onClick={handleClick}
    />
  );
};
